export default __webpack_public_path__ + "static/events-details-057ca01b0bd4cf3c31fe3a2a74f7a859.jpg";